module.exports = __webpack_public_path__ + "79f4ef5b2a8e42743cd79c373fde26b1.png";